import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import userReducer from "./slice/userSlice";
import { persistStore } from "redux-persist";

const persistConfig = {
  key: "userDetails",
  storage,
};

const persistedReducer = persistReducer(persistConfig, userReducer);

export const myStore = configureStore({
  reducer: {
    user: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(myStore);
